export default defineNuxtRouteMiddleware(async (to) => {
  const supabase = useSupabaseClient()
  const { data: { session } } = await supabase.auth.getSession()

  // Public routes that don't need authentication
  const publicRoutes = ['/auth/login', '/auth/register', '/auth/reset-password', '/unauthorized']
  if (publicRoutes.includes(to.path)) {
    return
  }

  // Handle unauthenticated users
  if (!session) {
    return navigateTo('/auth/login')
  }

  // Get business store
  const businessStore = useBusinessStore()
  const userRoleCookie = useCookie('user-role')

  // Get business info and role if needed
  if (!businessStore.businessId || !userRoleCookie.value) {
    try {
      const res = await $fetch('/api/user/business', {
        method: 'GET',
        retry: 1,
      })

      if (res?.business_id && res?.role) {
        businessStore.setBusinessId(res.business_id)
        userRoleCookie.value = res.role
      }
    }
    catch (error) {
      console.error('Failed to fetch business info:', error)
      return navigateTo('/auth/login')
    }
  }

  const userRole = userRoleCookie.value
  const serviceTypeCookie = useCookie('service_type')

  // Role-based access control
  if (userRole === 'Employee') {
    // Block access to admin routes
    if (to.path.startsWith('/app/')) {
      return navigateTo('/unauthorized')
    }

    // Redirect from root/login to POS
    if (to.path === '/' || to.path === '/auth/login') {
      return navigateTo('/store/pos')
    }
  }
  else if (userRole === 'Admin') {
    // Redirect from root/login to admin dashboard based on service type
    if (to.path === '/' || to.path === '/auth/login') {
      const serviceType = serviceTypeCookie.value
      if (serviceType === 'restaurant') {
        return navigateTo('/app/checks')
      }
      else {
        return navigateTo('/app/orders')
      }
    }
  }

  // Set business ID in store if present in route params
  if (to.params.businessId) {
    businessStore.setBusinessId(to.params.businessId as string)
  }
})
